"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.medibankFullOwnerDetails = exports.medibankBasicOwnerDetails = exports.MedibankQuoteToolContext = exports.MedibankDogRadio = exports.MedibankCoverDisplayOptions = exports.MedibankCatRadio = exports.MedibankAnimalRadioInputs = exports.MedibankAboutPet = exports.MedibankAboutOwner = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _defaultAboutPet = require("../../../defaults/quoteTools/defaultAboutPet");
var _defaultCoverDisplayOptions = require("../../../defaults/quoteTools/defaultCoverDisplayOptions");
var _defaultAboutOwner = require("../../../defaults/quoteTools/defaultAboutOwner");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var MedibankQuoteToolContext = exports.MedibankQuoteToolContext = {
  layout: {
    main: {
      heading: {
        headingText: 'Pet\'s details',
        headingSecondaryText: '',
        mandatoryText: 'Mandatory fields',
        showMandatoryText: true
      }
    }
  }
};
var MedibankCoverDisplayOptions = exports.MedibankCoverDisplayOptions = _objectSpread(_objectSpread({}, _defaultCoverDisplayOptions.DefaultCoverDisplayOptions), {}, {
  petSectionHeading: function petSectionHeading(pet) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "petCoverSectionHeading"
    }, pet.species === 'Dog' ? /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "dog-outline"
    }) : /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "cat-outline"
    }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, pet.petName), /*#__PURE__*/_react["default"].createElement("small", null, pet.species, " / ", pet.breed)));
  },
  disclaimer: null
});
var MedibankDogRadio = exports.MedibankDogRadio = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultDogRadio), {}, {
  icon: undefined
});
var MedibankCatRadio = exports.MedibankCatRadio = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultCatRadio), {}, {
  icon: undefined
});
var MedibankAnimalRadioInputs = exports.MedibankAnimalRadioInputs = [_objectSpread({}, MedibankDogRadio), _objectSpread({}, MedibankCatRadio)];
var MedibankAboutOwner = exports.MedibankAboutOwner = _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner), {}, {
  showCustomerSource: false,
  emailDisclaimerText: function emailDisclaimerText() {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "emailDisclaimer secondaryText"
    }, "By providing your email address you consent to receiving marketing communication about this quote. Opt out anytime.");
  },
  mandatoryText: 'Mandatory fields',
  showMandatoryText: true,
  ownerPostCodeInput: _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerPostCodeInput), {}, {
    inputmode: 'numeric'
  }),
  ownerEmailInput: _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput), {}, {
    label: 'Email (optional)',
    validation: {
      pattern: _objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput.validation.pattern)
    }
  }),
  ownerMobileInput: _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerMobileInput), {}, {
    placeholder: 'Enter phone number'
  }),
  ownerMembershipRadios: _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerMembershipRadios), {}, {
    groupLabel: 'Are you a Medibank or ahm health member?',
    groupLabelTooltip: /*#__PURE__*/_react["default"].createElement("span", null, "Medibank and ahm health members save 10% on their premium", /*#__PURE__*/_react["default"].createElement("sup", null, "#")),
    defaultRadioValue: 'yes'
  }),
  showMemberNumber: false,
  basicOwnerFormOrder: ['ownerBirthdateInput', 'ownerEmailInput', 'ownerPostCodeInput']
});
var medibankBasicOwnerDetails = exports.medibankBasicOwnerDetails = _objectSpread(_objectSpread({}, MedibankAboutOwner), {}, {
  ownerMemberNumberInput: {
    label: 'Medibank/ahm member number',
    placeholder: 'Enter member number',
    passThroughDefault: 'M99999999',
    clientNumberTypeCode: 'MEDIBANKM',
    validation: {
      required: 'Please enter your member number.'
    }
  }
});
var medibankFullOwnerDetails = exports.medibankFullOwnerDetails = _objectSpread(_objectSpread({}, MedibankAboutOwner), {}, {
  ownerEmailInput: _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput), {}, {
    labelTooltip: null,
    validation: {
      required: 'Please enter your email address.',
      pattern: _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput.validation.pattern), {}, {
        message: 'Email address is invalid'
      })
    }
  }),
  ownerVelocityMembershipNumber: {
    label: 'Velocity membership number',
    placeholder: 'Enter velocity membership number',
    validation: {
      pattern: {
        // allow only digits
        value: /^(0|[1-9]\d*)(\.\d+)?$/,
        message: 'Please enter valid Velocity membership number.'
      },
      required: 'Please enter your velocity membership number.'
    }
  },
  ownerMemberNumberInput: {
    label: 'Medibank/ahm member number',
    placeholder: 'Enter member number',
    passThroughDefault: 'M99999999',
    clientNumberTypeCode: 'MEDIBANKM',
    validation: {
      required: 'Please enter your member number.',
      pattern: {
        value: /^[0-9]{8}[A-Za-z]{0,1}$/,
        message: 'Please enter a valid member number.'
      }
    }
  }
});
var MedibankAboutPet = exports.MedibankAboutPet = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet), {}, {
  petSpeciesRadios: _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet.petSpeciesRadios), {}, {
    radioInputs: MedibankAnimalRadioInputs
  })
});